<div>
  <mat-card-header>
    <div style="width:700px">
      <mat-card-title>
        <label style="padding-top: 15px; font-size: 20px; font-weight: 500; color: #434a54;">Centro Logístico</label>
      </mat-card-title>
    </div>
    <div style="width:10%; cursor:pointer;">
      <mat-icon class="btnCancel" style="position: relative; float: right; margin-right: 5px" (click)="closePopup()">cancel</mat-icon>
    </div>
  </mat-card-header>

  <div style="padding-left: 80%">
    <mat-form-field style="width:100%">
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtrar">
    </mat-form-field>
  </div>
  <div class="table-container">
    <table mat-table [dataSource]="dataSource" matSort style="width:100%;">
      <ng-container matColumnDef="naoFiscal">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> naoFiscal </th>
        <td mat-cell *matCellDef="let element"> Não Fiscal </td>
      </ng-container>

      <ng-container matColumnDef="codigoCentroLogistico">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Centro Logístico </th>
        <td mat-cell *matCellDef="let element"> {{element.codigoCentroLogistico}} </td>
      </ng-container>

      <ng-container matColumnDef="descricao">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nome Centro Logístico </th>
        <td mat-cell *matCellDef="let element">{{element.descricao}} </td>
      </ng-container>

      <ng-container matColumnDef="enderecoCompleto">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Endereço </th>
        <td mat-cell *matCellDef="let element"> {{element.enderecoCompleto}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"></tr>
    </table>
  </div>
  <mat-paginator [pageSizeOptions]="[5, 50, 100, 500, 1000]" showFirstLastButtons></mat-paginator>
</div>